import axiosPost from "../axiosPost";

export const horarioRangoUpd = async ({
    gateHorarioId,
    gateHorarioRangoId,
    gateHorarioRangoVersion,
    gateHorarioRangoEntrada,
    gateHorarioRangoSalida,
    gateHorarioRangoDias,
}, credentials) => {
    const body = {
        service: "GateHorarioRangoUpd",
        params: {
            gateHorarioId,
            gateHorarioRangoId,
            gateHorarioRangoVersion,
            gateHorarioRangoEntrada,
            gateHorarioRangoSalida,
            gateHorarioRangoDias,
        },
    };

    return await axiosPost(body, credentials);
};
